import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useRegisterOverlay } from '@/contexts/OverlayStackContext';
import { openReportMailto } from '@/utils/openReportMailto';

interface ReportOverflowButtonProps {
  type: string;
  title: string;
  url?: string;
}

export function ReportOverflowButton({ type, title, url }: ReportOverflowButtonProps) {
  const { isAuthenticated, user } = useAuth();
  const [open, setOpen] = useState(false);
  useRegisterOverlay(open, () => setOpen(false));

  if (!isAuthenticated) {
    return null;
  }

  const handleReport = () => {
    openReportMailto({
      type,
      title,
      url: url || window.location.href,
      userId: user?.user_id,
    });
    setOpen(false);
  };

  return (
    <div className="relative">
      {open && (
        <div className="absolute right-0 mt-2 w-40 rounded-xl bg-white shadow-lg border border-gray-100 py-1 z-30">
          <button
            type="button"
            onClick={handleReport}
            className="w-full px-3 py-2 text-left text-sm font-medium text-[#0E1726] hover:bg-gray-50 active:bg-gray-100"
          >
            Laporkan
          </button>
        </div>
      )}
    </div>
  );
}
